<template>
  <div class="popup-container h-100 w-100 visible-mobile hidden-tablet fixed top-0 right-0 flex flex-column">
    <div class="tickets-popup align-self-end brdr-rectangle c-bg-white align-items-center flex-row flex">
      <div class="align-self-start fs12 py10 align-left lh15 pl10 pr5">
        <div class="bold popup-text justify-space-between flex pb2">
          <span v-html="title" />
          <span class="px11 align-self-end relative">
            <i
              class="icon icon-close regular pointer fs10"
              @click="close"
            />
          </span>
        </div>
        <div class="regular pt2">
          <span
            class="ls0"
            v-html="message"
          />
        </div>
      </div>
    </div>
    <div
      class="popup background c-bg-black fixed top-0 left-0 h-100 w-100"
      @click="close"
    />
  </div>
</template>

<script>

import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      showTicketsLeftPopup: state => state.ui.showTicketsLeftPopup
    }),
    title () {
      return this.$t('Availability on our website')
    },
    message () {
      return this.$t('This is the quantity of tickets currently available to purchase for this event on our website.')
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.catchScroll)
  },
  mounted () {
    window.addEventListener('scroll', this.catchScroll, { passive: true })
  },
  methods: {
    close () {
      this.$store.commit('ui/setShowTicketsLeftPopup', null)
    },
    catchScroll () {
      if (this.showTicketsLeftPopup) {
        this.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/base/global_vars';
@import '~theme/css/variables/grid';

.popup-container {
  z-index: map-get($z-index, modal);
  position: absolute;
  top: 0;
  left: 0;

  .popup-text {
    opacity: 0.8;

    .relative {
      top: -2px;
    }
  }

  .tickets-popup {
    z-index: map-get($z-index, modal);
    margin: 0;
    height: fit-content;
  }

  .popup {
    z-index: map-get($z-index, quantity-popup);
    opacity: 0.1;
  }
}
</style>
